(() => {
  const heroSelector = '[data-nexam-hero]';

  const getNextSection = (hero) => {
    const section = hero.closest('.shopify-section');

    if (section?.nextElementSibling) {
      return section.nextElementSibling;
    }

    return null;
  };

  const initialiseHero = (hero) => {
    if (!hero || hero.dataset.nexamHeroInitialised === 'true') return;

    hero.dataset.nexamHeroInitialised = 'true';

    const scrollButton = hero.querySelector('[data-nexam-scroll-next]');

    scrollButton?.addEventListener('click', () => {
      const nextSection = getNextSection(hero);

      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      window.scrollBy({ top: hero.offsetHeight * 0.8, behavior: 'smooth' });
    });
  };

  const initialiseWithin = (container = document) => {
    if (container.matches?.(heroSelector)) initialiseHero(container);
    container.querySelectorAll?.(heroSelector).forEach(initialiseHero);
  };

  initialiseWithin();

  document.addEventListener('shopify:section:load', (event) => {
    initialiseWithin(event.target);
  });
})();
